module.exports = __webpack_public_path__ + "static/media/transkrip.e696c7a0.jpg";